import React from "react";
import styled, { css } from "styled-components";
import baseStyle from "../../style";
import InputMask from "react-input-mask";
import { useFieldValue } from "../../hooks";

import * as colors from "../../../../assets/_base/colors";

const CNPJ = styled(InputMask)`
  ${baseStyle};

  ${(props) => {
    if (props.invalid) {
      return css`
        border: 1px solid ${colors.danger} !important;
        color: ${colors.danger} !important;

        :focus,
        :active {
          border: 2px solid ${colors.danger} !important;
          color: ${colors.danger} !important;
        }
      `;
    }
  }}
`;

export default (props) => {
  const [getFieldNameValue] = useFieldValue();

  function onChange(e, doubleValue) {
    if (props.onChange) {
      const data = getFieldNameValue({ type: "cnpj" }, e, doubleValue);
      props.onChange(data);
    }
  }

  return (
    <CNPJ
      mask="99.999.999/9999-99"
      placeholder="Ex: 47.960.950/0001-21"
      onChange={onChange}
      value={props.value}
    />
  );
};



// WEBPACK FOOTER //
// ./src/_components/Input/components/CNPJ/index.jsx